module.exports = __webpack_public_path__ + "media/images/icons/twitter_share_dark-b808f960aca6e9aa357232b9257cc92c.svg";